export type KPIOverviewSort = "health" | "off_target" | "name";

export interface KPIOverviewSortOption {
  value: KPIOverviewSort;
  label: string;
}

export const DEFAULT_KPI_OVERVIEW_SORT: KPIOverviewSort = "health";

export const KPI_OVERVIEW_SORTS: KPIOverviewSortOption[] = [
  { value: "health", label: "Health, worst first" },
  { value: "off_target", label: "Most metrics off target" },
  { value: "name", label: "Name" },
];

export const parseKPIOverviewSort = (value: string | null): KPIOverviewSort =>
  KPI_OVERVIEW_SORTS.find((sort) => sort.value === value)?.value ??
  DEFAULT_KPI_OVERVIEW_SORT;
